// extracted by mini-css-extract-plugin
module.exports = {"container":"Switch_container__3e6NK","slider":"Switch_slider__37-Jx","double":"Switch_double__1YCzV","disabled":"Switch_disabled__2zAMp"};